import Link from 'components/Link';
import Notification from 'components/Notification';
import {FC} from 'react';
import {jt, t} from 'ttag';

const DownloadNotificationWarning: FC = () => {
    const link = (
        <Link
            href="https://help.makeleaps.jp/ja/articles/8687205"
            isOpenInNewTab={true}
        >{t`Business Portals Manual`}</Link>
    );

    return (
        <Notification className="mt-4" icon="info" type="system">
            {jt`Caution: ZIP files are as uploaded by MakeLeaps users. Learn more in the ${link}.`}
        </Notification>
    );
};

export default DownloadNotificationWarning;
